module.exports = __webpack_public_path__ + "img/carousel-pagination-active.9f126600.svg";